import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Play } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { WebinarCard } from '../components/common/WebinarCard';
import { API_BASE } from '../config/api';

const API = `${API_BASE}/api`;

export default function WebinarsPage() {
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWebinars = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/webinars`);
        setWebinars(res.data || []);
      } catch (error) {
        console.error('Error fetching webinars:', error);
        setWebinars([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWebinars();
  }, []);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="font-heading text-4xl font-bold text-white mb-2">
            Masterclass Library
          </h1>
          <p className="text-zinc-400">
            Watch expert-led sessions and expand your knowledge
          </p>
          <span className="text-sm text-zinc-500 mt-2 block">
            {webinars.length} masterclass{webinars.length !== 1 ? 'es' : ''} available
          </span>
        </div>

        {/* Masterclasses Grid */}
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-navigate-surface border border-zinc-800 rounded-xl overflow-hidden animate-pulse">
                <div className="aspect-video bg-zinc-800" />
                <div className="p-4 space-y-3">
                  <div className="h-4 bg-zinc-800 rounded w-1/3" />
                  <div className="h-5 bg-zinc-800 rounded" />
                  <div className="h-4 bg-zinc-800 rounded w-2/3" />
                </div>
              </div>
            ))}
          </div>
        ) : webinars.length === 0 ? (
          <div className="text-center py-16">
            <Play className="h-12 w-12 text-zinc-600 mx-auto mb-4" />
            <h3 className="text-xl font-medium text-white mb-2">No masterclasses found</h3>
            <p className="text-zinc-400">
              Check back soon for new masterclasses
            </p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {webinars.map((webinar) => (
              <WebinarCard key={webinar.webinar_id} webinar={webinar} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
